"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'reports.shared.title': 'Udostępnione rozmowy',
    'reports.shared.description': 'Zobacz rozmowy, które zostały Ci udostępnione przez innych użytkowników',
    'reports.shared.failedToLoad': 'Nie udało się załadować udostępnionych rozmów',
    'reports.shared.retryButton': 'Spróbuj ponownie',
    'reports.shared.empty.title': 'Brak udostępnionych rozmów',
    'reports.shared.empty.description': 'Nie masz jeszcze żadnych rozmów udostępnionych przez innych użytkowników.',
    'reports.shared.createdAt': 'Utworzono',
    'reports.shared.lastActivity': 'Ostatnia aktywność',
    'reports.shared.model': 'Model AI',
    'reports.shared.unknownModel': 'Nieznany model',
    'reports.shared.unknownUser': 'Nieznany użytkownik',
    'reports.shared.viewButton': 'Zobacz',
    'reports.shared.sharedWith': 'Udostępnione dla',
    'reports.shared.noUsers': 'Brak użytkowników',
};
